import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CopyAssetModal from 'common/components/CopyAssetModal';
import { AssetType } from 'common/types/view';

import { getCopyAPIUrl } from '../../lib/StoryHelper';
import { selectors as storySelectors } from '../../store/selectors/StorySelectors';
import { closeCopyStoryModal, selectIsCopyStoryModalOpen } from '../../store/reducers/StoryCopierSlice';

export const StoryCopyModal = () => {
  const dispatch = useDispatch();
  const isStoryCopyModalOpen = useSelector(selectIsCopyStoryModalOpen);
  const dismissCopyModal = () => dispatch(closeCopyStoryModal());
  const storyTitle = useSelector(storySelectors.getStoryTitleToCopy);

  if (!isStoryCopyModalOpen) {
    return null;
  }

  const onCopy = (title: string): void => {
    window.open(`${getCopyAPIUrl()}?title=${title}`, '_blank', 'noopener,noreferrer');
    dismissCopyModal();
  };

  return (
    <CopyAssetModal
      assetTitle={storyTitle || ''}
      onCopy={onCopy}
      assetType={AssetType.Story}
      onDismiss={dismissCopyModal}
    />
  );
};
